const arr = [
    {
        coverImg: "https://source.unsplash.com/WLxQvbMyfas",
        Location: "J A P A N",
     googleMapsUrl: "https://www.google.com/maps/d/viewer?mid=1W9AtcwnYAqP1yVHr5YjhwmQa0eM&hl=en&ll=35.36479441415818%2C138.763048&z=13",

        name:"Mount Fuji",
        startDate: "12 Jan,2021",
        endDate: "24 Jan,2021",
        description:"Mount fuji is the tallest mountain in Japan, standing at 3,776 meters(12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japnese and foreign tourist."

    },

    {
        coverImg: "https://source.unsplash.com/JmuyB_LibRo",
        Location: "A U S T R A L I A",
        googleMapsUrl: "https://www.google.com/maps/d/viewer?mid=1NYBTZlF3StQEf65_sVbpMlskCoo&hl=en&ll=-33.856910000000006%2C151.215262&z=17",
        name:"Sydney Opera House",
        startDate: "27 May, 2021",
        endDate: "8 Jun, 2021",
        description:"The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings"

    },

    {
        coverImg: "https://source.unsplash.com/3PeSjpLVtLg",
        Location: "N O R W A Y",
        googleMapsUrl: "https://www.google.com/maps/d/viewer?hl=en_US&mid=1zi9bW9Zkl8ExIwx-ZNbeChUSK38&ll=62.091377%2C7.061932999999994&z=17",
        name:"Geirangerfjord",
        startDate: "01 Oct, 2021",
        endDate: "18 Nov, 2021",
        description:"The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality."

    },

]

export default arr


